import {IonGrid, IonRow, IonCol, IonModal, IonButtons, IonButton, IonIcon, IonContent, IonHeader, IonToolbar, IonTitle, useIonRouter, IonItemGroup, IonSelect, IonSelectOption} from "@ionic/react";
import {checkmarkOutline, chevronBack, scan} from "ionicons/icons";
import {QrReader} from "react-qr-reader";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import {OnResultFunction} from "react-qr-reader/src/types";
import CustomField from "../components/CustomField";
import {useFormInput, validateForm} from "../_/useForms";
import {useCallback, useContext, useEffect, useState} from "react";
import indexBy from "underscore/modules/indexBy";
import styles_Modal_3_11 from './Modal_3_11.module.scss';
import {Pg_B_1_Store} from "../store/Pg_B_Store";
import {Pg_C_4_Store, push_pg_C_1} from "../store/Pg_C_Store";
import {handleCommonFetchErrors, navToPg_A_1} from "./Utils";
import {push_pg_3_11__Comment, push_pg_3_1__Write} from "../store/Pg_3_Store";
import styles_Modal_3_1 from "./Modal_3_1_WriteArticle.module.scss";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import {v4 as uuidv4} from "uuid";
import MyUploadProgress from "./MyUploadProgress";
import MyUploadFail from "./MyUploadFail";
import ChunkedUploady, {UploadyContext, useBatchFinishListener, useChunkStartListener} from "@rpldy/chunked-uploady";
import styles_Pg_C_1 from "./Pg_C_1.module.scss";
import {useBatchAddListener, useRequestPreSend} from "@rpldy/uploady";
import Button from "@mui/material/Button";
import AddCircleOutlineSharp from "@mui/icons-material/AddCircleOutlineSharp";
import {fetch_pg_1_5} from "../store/Pg_1_Store";


const MAX_FILE_SIZE = 99 * 1000000; //99MB
const MyUploadButton = ({uploadedFile, setUploadedFile}) => {
    const uploady = useContext(UploadyContext);

    const [fileId, set_fileId] = useState("");
    useRequestPreSend(({items, options}) => {
        const _fileID = uuidv4() + "." + items[0].file.name.split(".").pop();
        set_fileId(_fileID);
        return {
            options: { //will be merged with the rest of the options
                destination: {
                    params: {
                        fileId: fileId
                    }
                }
            }
        };
    });
    useChunkStartListener(({chunk, chunkItem}) => {
        return {
            sendOptions: {
                method: "POST",
                paramName: "data",
                params: {
                    // chunkId: chunk?.index,
                    fileSize: chunkItem?.file?.size
                }
            }
        };
    });
    useBatchAddListener((batch) => {
        let result = true;
        (batch?.items as any)?.forEach((item, i) => {
            if (batch?.items[i]?.file?.size > MAX_FILE_SIZE) {
                // saveUploadedDocumentToProject({fileName: batch?.items[0]?.file.name,fileId: fileID,});
                result = result && false; //false will cancel.
            }
        })
        return result;
    });
    useBatchFinishListener((batch) => {
        let fileBag: string[] = [];

        (batch?.items as any)?.forEach((item, i) => {
            if (batch?.items[i]?.state === "finished") {
                // saveUploadedDocumentToProject({fileName: batch?.items[0]?.file.name,fileId: fileID,});

                let fileId_2 = JSON.parse(batch.items[i].uploadResponse.results[0].data).files[0].id;
                //console.log(fileId);

                fileBag.push(fileId_2);
            }
        })

        if (fileBag.length >= 1) {
            if (((uploadedFile?.length) ?? 0) > 0) {
                setUploadedFile(`${uploadedFile},${fileBag.join(',')}`);
            } else {
                setUploadedFile(`${fileBag.join(',')}`);
            }
        }
    });
    const handleUpload = useCallback(() => {
        uploady.showFileUpload({
            autoUpload: true
        });
    }, [uploady]);
    return (
        <Button onClick={handleUpload}>
            <AddCircleOutlineSharp/>
            <span>&nbsp;&nbsp;上傳圖片</span>
        </Button>
    );
};

const RenderForm = ({router, 文章Id, onResult = null, reload = null, dismiss = null}: {
    router: any,
    文章Id: any,
    reload: any, //[opt]
    dismiss: any, //[opt]
    onResult: any, //[opt]

}) => {
    const [uploadedFile, setUploadedFile] = useState<string | null>(null);

    //#region +Event
    const fields = [
        {
            id: "commentText",
            label: "留言內文",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "請輸入留言內文",
                    autoGrow: false,
                },
                state: useFormInput("")
            }
        },
        {
            id: "videoText",
            label: "影片連結",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "或影片 例: https://www.youtube.com/watch?v=C9V_1FzdqiY",
                    autoGrow: false,
                },
                state: useFormInput("")
            }
        },
        // {
        //     id: "File",
        //     label: "照片",
        //     required: true,
        //     input: {
        //         props: {
        //             type: "file",
        //             placeholder: "請張貼一個照片",
        //         },
        //         state: useFormInput("", (val, oldVal) => {
        //         })
        //     }
        // },
    ];

    let keyedFields = indexBy(fields, 'id');

    //#endregion

    const [errors, setErrors] = useState(false);

    const handleScan = result => {
        if (result) {
            //setQRData(result);
            //play();
            //handleSuccess(result);
            alert(`代碼: ${result.text}`);
            keyedFields.code.input.state.reset(result.text);
            //onResult(result);
        }
    }


    const push_writeComment = async () => {
        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const commentText = fields && (keyedFields.commentText as any).input.state.value;
            const videoText = fields && (keyedFields.videoText as any).input.state.value;

            if (uploadedFile == null && !videoText && !commentText) {
                alert('請上傳【一張照片】或填寫【影片連結】或填寫留言內容');
                return;
            }

            let errorObj = await push_pg_3_11__Comment({
                p1: 文章Id,
                p2: commentText,
                opt_p3: uploadedFile,
                opt_p4: videoText,
            });
            if (errorObj) {
                handleCommonFetchErrors(router, errorObj);
            } else {
                //alert('謝謝註冊，現在請輸入剛註冊的帳密登入');
                //navToPg_A_1(router);
                alert('留言成功')

                if (dismiss) {
                    dismiss();
                }
                if (onResult) {
                    onResult(true);
                }
            }
        }
    }

    return <>
        <IonItemGroup>
            {/*<IonItemDivider>*/}
            {/*    <IonLabel>選填</IonLabel>*/}
            {/*</IonItemDivider>*/}
            <IonRow>
                <IonCol className={'flex'}>
                    {/*<CustomField key={keyedFields.File.id} field={keyedFields.File} errors={errors} noLabel={true}/>*/}
                    <ChunkedUploady
                        destination={{url: "/MemberUploadHandler.ashx"}}
                        chunkSize={5242880}
                        multiple={true}
                    >
                        <div className={`${styles_Modal_3_1.h50px} ${styles_Modal_3_1.multipleImgs}`}>
                            {Ln_TokenPictureSetCoverImg({
                                圖片組: uploadedFile,
                                名稱: 'cover',
                                type: 'multiple',
                            })}
                        </div>
                        <div>
                            <MyUploadButton uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}/>
                            <MyUploadProgress/>
                            <MyUploadFail/>
                        </div>
                    </ChunkedUploady>
                </IonCol>
            </IonRow>
        </IonItemGroup>

        <IonRow>
            <IonCol>
                <CustomField field={keyedFields.videoText} errors={errors} noLabel={false}/>
            </IonCol>
        </IonRow>

        <IonRow>
            <IonCol>
                <CustomField key={keyedFields.commentText.id} inputClassName={styles_Modal_3_1.maxHeight} field={keyedFields.commentText} errors={errors} noLabel={false} textType="textarea"/>
            </IonCol>
        </IonRow>

        <IonRow className="ion-justify-content-center ion-text-center ion-margin-top ">
            <IonCol>
                <IonButton fill={"solid"} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    //_push_pg_4_2__AddCouponBookmark(Item_合約獎勵.合約獎勵Id);
                    // alert('代碼為空，無法兌換')
                    push_writeComment();

                    return false;
                }}>
                    送出
                </IonButton>
            </IonCol>
        </IonRow>
    </>

}

export const Modal_3_11_WriteComment = ({文章Id, dismiss, onResult}) => {

    const router = useIonRouter();

    //#region Back button
    useEffect(() => {
        let callback: any = (ev) => {
            // ev.detail.register(10, () => {
            //     console.log('Handler was called!');
            // });

            dismiss();
        };

        document.addEventListener('ionBackButton', callback);
        // Remove listener on unmount
        return () => document.removeEventListener("ionBackButton", callback);
    }, []);
    //#endregion


    const hasLoaded = true;

    // const fields = useLoginFields();
    // let keyedFields = indexBy(fields, 'id');


    const [errors, setErrors] = useState(false);

    return <>
        <IonHeader>
            <IonToolbar>
                <IonTitle>我要留言</IonTitle>
                <IonButtons slot="start">
                    <IonButton onClick={dismiss}>
                        <IonIcon size="large" icon={chevronBack} style={{marginLeft: "-0.7rem"}}/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
            <IonGrid>
                <IonRow className="ion-justify-content-center">
                    <IonCol>

                    </IonCol>
                </IonRow>

                {hasLoaded &&
                    <RenderForm router={router} 文章Id={文章Id} onResult={onResult} reload={null} dismiss={dismiss}/>
                }


            </IonGrid>
        </IonContent>
    </>;
};
